/* CN Header — Sticky + Hamburger */
class CNStickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-cn-header');
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = function() { this.preventReveal = true; }.bind(this);
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();

    // Hamburger
    this.menuToggle = this.querySelector('.cn-header__menu-toggle');
    this.nav = this.querySelector('.cn-header__nav');
    this.overlay = this.querySelector('.cn-header__nav-overlay');

    if (this.menuToggle) {
      this.menuToggle.addEventListener('click', this.onMenuToggle.bind(this));
    }
    if (this.overlay) {
      this.overlay.addEventListener('click', this.closeNav.bind(this));
    }

    document.addEventListener('keyup', function(e) {
      if (e.key === 'Escape') this.closeNav();
    }.bind(this));
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', this.header.offsetHeight + 'px');
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    var self = this;
    var observer = new IntersectionObserver(function(entries) {
      self.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }

  onScroll() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        var self = this;
        this.isScrolling = setTimeout(function() { self.preventReveal = false; }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosures();
    this.closeNav();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosures() {
    this.disclosures = this.disclosures || this.querySelectorAll('header-menu');
    this.disclosures.forEach(function(d) { if (d.close) d.close(); });
  }

  onMenuToggle() {
    if (this.nav.classList.contains('cn-header__nav--open')) {
      this.closeNav();
    } else {
      this.openNav();
    }
  }

  openNav() {
    this.nav.classList.add('cn-header__nav--open');
    this.menuToggle.setAttribute('aria-expanded', 'true');
    if (this.overlay) {
      this.overlay.style.display = 'block';
      var overlay = this.overlay;
      requestAnimationFrame(function() { overlay.classList.add('cn-header__nav-overlay--visible'); });
    }
    document.body.classList.add('overflow-hidden-tablet');
  }

  closeNav() {
    if (!this.nav || !this.nav.classList.contains('cn-header__nav--open')) return;
    this.nav.classList.remove('cn-header__nav--open');
    if (this.menuToggle) this.menuToggle.setAttribute('aria-expanded', 'false');
    if (this.overlay) {
      this.overlay.classList.remove('cn-header__nav-overlay--visible');
      var overlay = this.overlay;
      setTimeout(function() { overlay.style.display = ''; }, 300);
    }
    document.body.classList.remove('overflow-hidden-tablet');
  }
}

customElements.define('cn-sticky-header', CNStickyHeader);
